import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

/**
 * Slider component
 */
export default class Slider extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    refs: ['slider', 'prev', 'next', 'pagination'],
    options: {
      pagination: {
        type: String,
        default: 'bullets',
      },
      spaceBetween: {
        type: Number,
        default: 0,
      },
      slidesPerView: {
        type: Number,
        default: 0,
      },
      autoplay: {
        type: Boolean,
        default: false,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: this.$options.spaceBetween,
      autoplay: this.$options.autoplay,
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
        type: this.$options.pagination,
      },
      breakpoints: {
        1024: {
          slidesPerView: this.$options.slidesPerView > 0 ? this.$options.slidesPerView : 'auto',
        },
      },
    });
  }
}
